/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Operational_ProtocolInputs */

const en_operational_protocol = /** @type {(inputs: Operational_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operational Protocol`)
};

const es_operational_protocol = /** @type {(inputs: Operational_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protocolo Operativo`)
};

const fr_operational_protocol = /** @type {(inputs: Operational_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protocole opérationnel`)
};

const de_operational_protocol = /** @type {(inputs: Operational_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betriebsprotokoll`)
};

const id_operational_protocol = /** @type {(inputs: Operational_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protokol Operasional`)
};

/** @type {(inputs: Operational_ProtocolInputs) => LocalizedString} */
const ja_operational_protocol = en_operational_protocol;

/** @type {(inputs: Operational_ProtocolInputs) => LocalizedString} */
const zh_operational_protocol = en_operational_protocol;

/** @type {(inputs: Operational_ProtocolInputs) => LocalizedString} */
const ar_operational_protocol = en_operational_protocol;

/** @type {(inputs: Operational_ProtocolInputs) => LocalizedString} */
const it_operational_protocol = en_operational_protocol;

/** @type {(inputs: Operational_ProtocolInputs) => LocalizedString} */
const ru_operational_protocol = en_operational_protocol;

/** @type {(inputs: Operational_ProtocolInputs) => LocalizedString} */
const pt_operational_protocol = en_operational_protocol;

/** @type {(inputs: Operational_ProtocolInputs) => LocalizedString} */
const ko_operational_protocol = en_operational_protocol;

/**
* | output |
* | --- |
* | "Operational Protocol" |
*
* @param {Operational_ProtocolInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const operational_protocol = /** @type {((inputs?: Operational_ProtocolInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Operational_ProtocolInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_operational_protocol(inputs)
	if (locale === "es") return es_operational_protocol(inputs)
	if (locale === "fr") return fr_operational_protocol(inputs)
	if (locale === "de") return de_operational_protocol(inputs)
	if (locale === "ja") return ja_operational_protocol(inputs)
	if (locale === "zh") return zh_operational_protocol(inputs)
	if (locale === "ar") return ar_operational_protocol(inputs)
	if (locale === "id") return id_operational_protocol(inputs)
	if (locale === "it") return it_operational_protocol(inputs)
	if (locale === "ru") return ru_operational_protocol(inputs)
	if (locale === "pt") return pt_operational_protocol(inputs)
	return ko_operational_protocol(inputs)
});